import '~style/components/simple-tabs/index.scss';
import SimpleTabs from '~scripts/component/simple-tabs';
import SimpleTabsFakeDropdown from '~scripts/component/simple-tabs/simple-tabs-fake-dropdown';

// Block style loaded last so that we can override styles for SimpleTabs component
import '~style/blocks/solutions-tabs/index.scss';

/**
 * Builds multiple Tabs components, including nested ones, for "Solutions Tab" block
 */
const SolutionsTab = {
  _tabInstances: [],

  _counter: 0,

  _selectors: {
    topLevelTabs: {
      container: '.js-solutions-tabs',
      header: '.js-solutions-tabs-header',
      body: '.js-solutions-tabs-body'
    },
    nestedTabs: {
      container: '.js-solutions-tabs-nested',
      header: '.js-solutions-tabs-nested-header',
      body: '.js-solutions-tabs-nested-body'
    }
  },

  init() {
    const self = this;

    // Instantiates top level tabs
    document.querySelectorAll(this._selectors.topLevelTabs.container).forEach(node => {
      // Only creates instances if not already initialised
      if ( node.getAttribute('data-init') === null ) {
        self.createNewInstance(node, 'topLevelTabs');
      }
    });

    // Instantiates nested tabs
    document.querySelectorAll(this._selectors.nestedTabs.container).forEach(node => {
      // Only creates instances if not already initialised
      if ( node.getAttribute('data-init') === null ) {
        self.createNewInstance(node, 'nestedTabs');
      }
    });
  },

  /**
   * @param node
   * @param selectorGroupName (either 'topLevelTabs' or 'nestedTabs')
   */
  createNewInstance(node, selectorGroupName) {
    const containerEl = node.closest( this._selectors[selectorGroupName].container );

    // Generates unique container id
    const containerId = 'simple-tabs-inst-' + this._counter;
    this._counter ++;

    // Adds id to container element
    containerEl.setAttribute('data-container-id', containerId);

    // Used to specify selectors within this container only
    const containerSelector = this._selectors[selectorGroupName].container + '[data-container-id="'+ containerId +'"]';

    const instance = new SimpleTabs({
      container: containerSelector,
      header: containerSelector + ' > ' + this._selectors[selectorGroupName].header,
      body: containerSelector + ' > ' + this._selectors[selectorGroupName].body
    });

    // Adds a fake dropdown modification for nested tabs (small breakpoints).
    // Requires more than 1 nested tab to exist.
    if ( selectorGroupName === 'nestedTabs'  && parseInt(containerEl.getAttribute('data-tab-count')) > 1 ) {
      new SimpleTabsFakeDropdown( containerEl );
    }

    this._tabInstances.push({
      containerId,
      instance
    });

    // Marks container as initialised to prevent duplicate initialisations
    containerEl.setAttribute('data-init', '1');
  }
};

SolutionsTab.init();



